<template>
  <v-card class="filter-panel" elevation="0">
    <h1 class="filter-title">Gestion de Usuarios</h1>
    <v-form ref="form" @submit.prevent="applyFilters" @keydown.enter.prevent="applyFilters">
      <v-row dense>
        <v-col cols="12" md="4">
          <v-text-field
            label="Nombre de usuario"
            v-model="nameFilter"
            variant="outlined"
            density="comfortable"
            clearable
          />
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field
            label="Compania"
            v-model="companyFilter"
            variant="outlined"
            density="comfortable"
            clearable
          />
        </v-col>
        <v-col cols="12" md="4">
          <v-select
            label="Rol"
            v-model="roleFilter"
            :items="roleNameList"
            variant="outlined"
            density="comfortable"
            clearable
          />
        </v-col>
      </v-row>

      <div class="filter-actions">
        <v-btn type="button" @click="clearFilters" color="secondary" variant="tonal">Limpiar filtros</v-btn>
        <v-btn type="submit" color="primary">Filtrar</v-btn>
      </div>
    </v-form>
  </v-card>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'FilterFormUser',
  props: {
    roleNameList: Array
  },

  data: () => ({
    nameFilter: '',
    companyFilter: '',
    roleFilter: ''
  }),

  computed: {
    ...mapGetters('userModule', ['getUsers'])
  },
  watch: {
    'getUsers': function () {
      this.$refs.form.reset()
    }
  },

  methods: {
    applyFilters () {
      let filters = {
        username: this.nameFilter,
        companyName: this.companyFilter,
        roleName: this.roleFilter
      }
      this.$store.dispatch('userModule/filterItems', filters)
    },

    clearFilters () {
      this.$store.dispatch('userModule/refreshFilteredusers')
      this.$refs.form.reset()
    }
  }
}
</script>
